import {Component, input} from '@angular/core';
import {DatePipe} from '@angular/common';
import {Divider} from 'primeng/divider';
import {TranslocoPipe} from '@jsverse/transloco';
import {AuditInfo} from '@frontend/shared-api';

@Component({
  selector: 'app-audit-info',
  imports: [DatePipe, Divider, TranslocoPipe],
  templateUrl: './audit-info.component.html',
})
export class AuditInfoComponent {
  readonly auditInfo = input<AuditInfo | null>(null);
}
